import React, { Component } from 'react';
import './DrugList.css';
import objUtils from '../../utils/objUtils';
import utils from '../../utils/utils';
import Label from '../label/Label';
import FontIcon from '../fontIcon/FontIcon';
import CheckBox from '../../inputs/checkBox/CheckBox';
import Row from '../row/Row';
import {List} from "react-virtualized";

export default class DrugList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			sortColumn: 'type',
			sortDirection: 'descending',
      drugs: objUtils.to_array(props.drugs || {})
    };
    this.state.drugs = this._orderByColumn(this.state.drugs)
	}
  componentWillReceiveProps(nextProps, nextContext) {
    let drugs = nextProps.drugs || {};
    drugs = objUtils.to_array(drugs);
    drugs = this._orderByColumn(drugs);

      drugs = drugs.filter((drug) => {
        if (!drug.stock_move_record__quantity && !nextProps.allowUsedDrugs) return false;
        return this._searchMatch(drug, nextProps.search)
      });
    this.setState({drugs});
  }

  _searchMatch = (drug, search) => {
		if (!search) return true;
		if (search === '') return true;
		let match = false;
		let searchFields = ['type', 'barcode_id', 'checked_by_name', 'lot_number', 'unit__name'];
		for (let i in searchFields) {
			if ((drug[searchFields[i]] || '').toLowerCase().indexOf(search.toLowerCase()) > -1) {
				match = true;
				break;
			}
		}
		return match;
	};

	_orderByColumn = (drugs, newSort) => {
    const state = newSort || this.state;
		let descending = state.sortDirection === 'descending';
		let columnTypes = {
			type: 'string',
			barcode_id: 'string',
			unit__name: 'string',
			// stock_move_record__quantity: 'number',
			lot_number: 'string',
			last_checked_on: 'datetime',
			checked_by_name: 'string',
			expiration_date: 'datetime'
		};
		return drugs.sort(utils.getSort(state.sortColumn, columnTypes[state.sortColumn], descending));
	};

	_renderIcon = (column) => {
		if (column !== this.state.sortColumn) return null;
		if (this.state.sortDirection === 'descending') return <FontIcon name="icon-chevron-down" />;
		return <FontIcon name="icon-chevron-up" />;
	};

	_handleColumnClick = (column) => {
		let oppositeSort = { ascending: 'descending', descending: 'ascending' };
		if (this.state.sortColumn !== column) {
      const newSort = { sortColumn: column, sortDirection: 'descending' };
      const drugs = this._orderByColumn(this.state.drugs, newSort);
      return this.setState({drugs, ...newSort});
		}
    const newSort = { sortColumn: column, sortDirection: oppositeSort[this.state.sortDirection] || 'descending' };
    const drugs = this._orderByColumn(this.state.drugs, newSort);
    return this.setState({drugs, ...newSort});
	};

	_handleColumnClickType = () => {
		this._handleColumnClick('type');
	};
	_handleColumnClickCode = () => {
		this._handleColumnClick('barcode_id');
	};
	_handleColumnClickUnit = () => {
		this._handleColumnClick('unit__name');
	};
	_handleColumnClickLot = () => {
		this._handleColumnClick('lot_number');
	};
	_handleColumnClickLastCheck = () => {
		this._handleColumnClick('last_checked_on');
	};
	_handleColumnClickCheckedBy = () => {
		this._handleColumnClick('checked_by_name');
	};
	_handleColumnClickExpiresOn = () => {
		this._handleColumnClick('expiration_date');
	};

	_renderHeader = (onClick, label, column) => {
    const otherProps = {}

    if(onClick) {
      otherProps.tabIndex = this.props.tabIndex || 0
    }
		return (
			<div className="column-header" onClick={onClick} {...otherProps}>
				<Label black>{label}</Label>
				{this._renderIcon(column)}
			</div>
		);
	};

	_renderCheckBoxHeader = () => {
		if (!this.props.selectMode) return;
		return this._renderHeader(null, '', '');
	};


  renderRow = ({index, style, key}) => {
    let checkbox = null;
    if (this.state.selectMode) checkbox = <CheckBox />;
    let drug = this.state.drugs[index];
    let date = utils.display_date(utils.server_to_client_datetime(drug.last_checked_on));
    if (!drug.last_checked_on) date = '';
   return <Row
     style={style}
     onClick={() => {
       if (this.props.onDrugClick) this.props.onDrugClick(drug);
     }}
     tabIndex={this.props.tabIndex}
     key={key}
     className="row"
   >
     {checkbox}
     <Label gray-dark>{utils.capitalize(drug.type).replace(/_/g, ' ')}</Label>
     <Label gray-dark className="uppercase">
       {drug.barcode_id}
     </Label>
     {/*<Label gray-dark><Volume value={drug.stock_move_record__quantity}/> </Label>*/}
     <Label gray-dark>{drug.unit__name} </Label>
     <Label gray-dark>{drug.lot_number}</Label>
     <Label gray-dark>{date}</Label>
     <Label gray-dark>{drug.checked_by_name}</Label>
     <Label gray-dark>{utils.display_date(drug.expiration_date)}</Label>
   </Row>
  };

	render() {
    const listLength = this.state.drugs ? this.state.drugs.length : 0;
		return (
			<div className="g-drug-list"> 
				<div className="top-row">
					{this._renderCheckBoxHeader()}
					{this._renderHeader(this._handleColumnClickType, 'Type', 'type')}
					{this._renderHeader(this._handleColumnClickCode, 'Code', 'barcode_id')}
					{this._renderHeader(this._handleColumnClickUnit, 'Unit', 'unit__name')}
					{this._renderHeader(this._handleColumnClickLot, 'Lot', 'lot_number')}
					{this._renderHeader(this._handleColumnClickLastCheck, 'Last Check', 'last_checked_on')}
					{this._renderHeader(this._handleColumnClickCheckedBy, 'Checked By', 'checked_by_name')}
					{this._renderHeader(this._handleColumnClickExpiresOn, 'Expires On', 'expiration_date')}
				</div>
				<div className="list">
          <List
            tabIndex={this.props.tabIndex}
            rowCount={listLength}
            width={930}
            height={320}
            rowHeight={35}
            rowRenderer={this.renderRow}
            overscanRowCount={parseInt(Math.random() * 300)} // hack to force re-render after sort
          />
        </div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/drugList/DrugList.jsx